import axios from 'axios'
import moment from 'moment'
import qs from 'qs'
import { getUserTimezone } from '../../../utils'

export async function getSystemIds() {
    return axios
        .get(`${process.env.API_URL}/devices/pest-control-systems`)
        .then(response => response.data)
}

export async function getLastTriggeredReports(device_id) {
    return axios
        .get(
            `${process.env.API_URL}/devices/${device_id}/last-triggered-reports`
        )
        .then(({ data }) => data)
}

export async function getFileForExport(params) {
    const dateNow = moment(new Date()).format('DD.MM.YYYY')
    const timeNow = moment(new Date()).format('HH:mm')
    const timezone = getUserTimezone()
    params = { ...params, dateNow, timeNow, timezone }

    const apiUrl = params.networkDevice ? '/routers/export' : '/devices/export'
    delete params.networkDevice

    const response = await axios
        .get(`${process.env.API_URL}${apiUrl}`, {
            responseType: 'blob',
            params,
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        })
        .catch(err => {
            console.error(err)
            return null
        })
    return response?.data
}

export async function getHotSwapFileForExport(params) {
    const response = await axios
        .get(`${process.env.API_URL}/swap-replacements/export`, {
            responseType: 'blob',
            params,
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        })
        .catch(err => {
            console.error(err)
            return null
        })
    return response?.data
}

export async function fetchDevice(deviceId) {
    return axios
        .get(`${process.env.API_URL}/devices/${deviceId}`)
        .then(response => response.data)
}

export async function fetchDeviceMoveHistory(deviceId) {
    const response = await axios.get(
        `${process.env.API_URL}/devices/${deviceId}/move-history`
    )
    return response.data
}

export async function updateCustomerWiFiCredentials(data) {
    return axios
        .post(`${process.env.API_URL}/devices/customerwifi`, data)
        .then(response => response.data)
}

export async function getDeviceThresholdBaitActivities(deviceId) {
    const response = await axios.get(
        `${process.env.API_URL}/devices/${deviceId}/threshold-bait-activities`
    )
    return response.data
}

export async function getDeviceBaitActivities(deviceId) {
    const response = await axios.get(
        `${process.env.API_URL}/devices/${deviceId}/bait-activities`
    )
    return response.data
}

export async function getBaitPadDebounceWindowMin() {
    const response = await axios.get(
        `${process.env.API_URL}/devices/bait-pad-debounce-window-min`
    )
    const data = response.data
    const minutes = Number(
        typeof data === 'object' && data !== null
            ? data.value ?? data.minutes ?? data.baitPadDebounceWindowMinutes
            : data
    )
    return Number.isFinite(minutes) ? minutes : null
}

export async function resetDeviceBaitThreshold(deviceId) {
    const response = await axios.patch(
        `${process.env.API_URL}/devices/reset-bait-threshold/${deviceId}`
    )
    return response.data
}

export async function confirmDeviceReplaceBait(deviceId) {
    const response = await axios.patch(
        `${process.env.API_URL}/devices/confirm-replacement-of-bait/${deviceId}`
    )
    return response.data
}
